/* @flow */

import React from 'react'
import styled from 'styled-components'

import {
  ControlLabel,
  FormControl,
} from '../../../infrastructure/components/Forms'

const ImageDownloadTransformations = ({ onChange, transformations }) => {
  const onAdd = React.useCallback(() => {
    onChange([
      ...transformations,
      {
        format: 'jpg',
        height: 'auto',
        width: 'auto',
      },
    ])
  }, [onChange, transformations])

  const onRemove = React.useCallback(
    i => {
      const updated = [...transformations]

      updated.splice(i, 1)

      onChange(updated)
    },
    [onChange, transformations]
  )

  const onUpdate = React.useCallback(
    (i, key, value) => {
      const updated = [...transformations]

      updated[i] = {
        ...updated[i],
        [key]: value,
      }

      onChange(updated)
    },
    [onChange, transformations]
  )

  return (
    <div>
      {transformations.map((transformation, i) => {
        return (
          <SizeContainer>
            <div className="row">
              <div className="col-xs-4">
                <ControlLabel>Height</ControlLabel>

                <div className="radio radio-success">
                  <input
                    onChange={() => onUpdate(i, 'height', 'auto')}
                    type="radio"
                    id={`transformations-${i}-height-auto`}
                    checked={transformation.height === 'auto'}
                  />
                  <label htmlFor={`transformations-${i}-height-auto`}>
                    Auto
                  </label>
                </div>

                <div className="radio radio-success">
                  <input
                    onChange={() => onUpdate(i, 'height', 0)}
                    type="radio"
                    id={`transformations-${i}-height-fixed`}
                    checked={transformation.height !== 'auto'}
                  />
                  <label htmlFor={`transformations-${i}-height-fixed`}>
                    Fixed height
                  </label>
                </div>

                {transformation.height !== 'auto' && (
                  <div>
                    <ControlLabel>Height in pixels</ControlLabel>
                    <FormControl
                      onChange={e => onUpdate(i, 'height', e.target.value)}
                      value={transformation.height}
                    />
                  </div>
                )}
              </div>
              <div className="col-xs-4">
                <ControlLabel>Width</ControlLabel>

                <div className="radio radio-success">
                  <input
                    onChange={() => onUpdate(i, 'width', 'auto')}
                    type="radio"
                    id={`transformations-${i}-width-auto`}
                    checked={transformation.width === 'auto'}
                  />
                  <label htmlFor={`transformations-${i}-width-auto`}>
                    Auto
                  </label>
                </div>

                <div className="radio radio-success">
                  <input
                    onChange={() => onUpdate(i, 'width', 0)}
                    type="radio"
                    id={`transformations-${i}-width-fixed`}
                    checked={transformation.width !== 'auto'}
                  />
                  <label htmlFor={`transformations-${i}-width-fixed`}>
                    Fixed width
                  </label>
                </div>

                {transformation.width !== 'auto' && (
                  <div>
                    <ControlLabel>Width in pixels</ControlLabel>
                    <FormControl
                      onChange={e => onUpdate(i, 'width', e.target.value)}
                      value={transformation.width}
                    />
                  </div>
                )}
              </div>
              <div className="col-xs-4">
                <button
                  type="button"
                  className="btn btn-sm btn-white"
                  onClick={() => onRemove(i)}
                >
                  Remove size
                </button>
              </div>
            </div>
          </SizeContainer>
        )
      })}

      <ActionBarContainer>
        <button type="button" className="btn btn-success" onClick={onAdd}>
          <span className="glyphicon glyphicon-plus" /> Add size
        </button>

        {transformations.length === 0 && (
          <TipContainer>
            <span className="glyphicon glyphicon-arrow-left" /> Let Traede
            resize the images for you. Click this button to create custom sizes
          </TipContainer>
        )}
      </ActionBarContainer>
    </div>
  )
}

export default ImageDownloadTransformations

const TipContainer = styled.div.attrs({ className: 'alert alert-info ' })`
  flex: 1;
  margin-bottom: 0;
  margin-left: 10px;
`

const SizeContainer = styled.div`
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  padding-bottom: 10px;
`

const ActionBarContainer = styled.div`
  display: flex;
`
